export const NOT_ACCREDITED_FORBIDDEN_CODE = 'NOT_ACCREDITED_FORBIDDEN';

export const DUPLICATE_ORGANIZATION_NAME_CODE = 'DUPLICATE_ORGANIZATION_NAME';

/** The owner already has an active import (session or legacy job) — creating a new one is rejected. */
export const CONTACT_IMPORT_ACTIVE_JOB_EXISTS_CODE =
  'ADDRESS_BOOK.CONTACT_IMPORT.ACTIVE_JOB_EXISTS';
export const CONTACT_IMPORT_JOB_NOT_FOUND_CODE = 'ADDRESS_BOOK.CONTACT_IMPORT.JOB_NOT_FOUND';
export const CONTACT_IMPORT_PROVIDER_NOT_CONFIGURED_CODE =
  'ADDRESS_BOOK.CONTACT_IMPORT.PROVIDER_NOT_CONFIGURED';
